const $file = $('.js-file')
const allowedExtensions = /(\.doc|\.docx|\.pdf|\.txt)$/i

$('body').on('change', '.js-file-input', function() {
	const $this = $(this)
	const maxUploadSize = $this.attr('data-max')
	const $btn = $this.closest('.js-file').find('.js-file-btn span')
	const name = $this.val().split(/\\|\//).pop()
	const truncated = name.length > 50 ? '...'+ name.substr(name.length - 50) : name

	if(fileValidation($this[0], maxUploadSize)){
		$btn.html(truncated)
	}
})

function fileValidation(fileInput, maxUploadSize){
	var filePath = fileInput.value
	var fileSize = fileInput.files[0].size / Math.pow(1024,2)

	if(!allowedExtensions.exec(filePath)){
		alert('Jsou povoleny pouze formáty DOC, DOCX, PDF nebo TXT')
		fileInput.value = ''
		return false
	}
	else if(fileSize > maxUploadSize){
			alert('Nahraný soubor přesahuje ' + maxUploadSize + 'MB. Zmenšete ho a znovu nahrajte.')
		fileInput.value = ''
		return false
	}
	else{
		if (fileInput.files && fileInput.files[0]) {
			return true
		}
	}
}
